import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPOSLayout from './components/Layout/MainPOSLayout';
import PrivateRoute from './components/wrapper/PrivateRoute';

import AdminLogin from './pages/Admin/AdminLogin';
import AdminMenu from './pages/Admin/AdminMenu';

import MozoRegister from './pages/Admin/MozoRegister';
import ProductoAdmin from './pages/Admin/ProductoAdmin';
import EditarProducto from './pages/EditarProducto';
import ProductoRegister from './pages/ProductoRegister';

import CategoriaAdmin from './pages/Admin/CategoriaAdmin';
import CategoriaEdit from './pages/CategoriaEdit';
import CategoriaRegister from './pages/CategoriaRegister';

import DescuentoAdmin from './pages/Admin/DescuentoAdmin';
import RegistroDescuento from './pages/RegistroDescuento';
import EditarDescuento from './pages/EditarDescuento';

import LiquidacionPropina from './pages/Admin/LiquidacionPropina';

import TicketPrinter from './components/TicketPrinter'; // Asegurate de que esté importado correctamente

import ProveedorAdmin from './pages/Admin/ProveedorAdmin';
import CompraAdmin from './pages/Admin/CompraAdmin';
import TurnoCajaAdmin from './pages/Admin/TurnoCajaAdmin';
import FlujoCajaAdmin from './pages/Admin/FlujoCajaAdmin';

import EsquemasAdmin from './pages/Admin/EsquemasAdmin';
import CotizacionAdmin from './pages/Admin/CotizacionAdmin';
import GastoAdmin from './pages/Admin/GastoAdmin';
import StockAdmin from './pages/Admin/StockAdmin';
import UserRegister from './pages/Admin/UserRegister';
import TestTicketPage from './components/testticketpage';
import TicketPrinterWrapper from './components/wrapper/TicketPrinterWrapper';



function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

 



  return (
    <Router>
      <Routes>
        {/* Ruta principal del POS */}
        <Route path="/" element={<MainPOSLayout />} />
        {/*<Route path="/admin-login" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />*/}

        {/*<Route path="/admin-login" element={<AdminLogin />} />*/}
        <Route path="/admin-login" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />


        {/* Rutas protegidas para administración */}
        <Route path="/admin" element={<PrivateRoute><AdminMenu /></PrivateRoute>} />
        <Route path="/registro-mozo" element={<PrivateRoute><MozoRegister /></PrivateRoute>} />
        <Route path="/admin-productos" element={<PrivateRoute><ProductoAdmin /></PrivateRoute>} />
        <Route path="/editar-producto/:id" element={<PrivateRoute><EditarProducto /></PrivateRoute>} />
        <Route path="/registro-producto" element={<PrivateRoute><ProductoRegister /></PrivateRoute>} />
        <Route path="/admin-categorias" element={<PrivateRoute><CategoriaAdmin /></PrivateRoute>} />
        <Route path="/editar-categoria/:id" element={<PrivateRoute><CategoriaEdit /></PrivateRoute>} />
        <Route path="/registro-categoria" element={<PrivateRoute><CategoriaRegister /></PrivateRoute>} />
        <Route path="/admin-promociones" element={<PrivateRoute><DescuentoAdmin /></PrivateRoute>} />
        <Route path="/registro-descuento" element={<PrivateRoute><RegistroDescuento /></PrivateRoute>} />
        <Route path="/editar-descuento/:id" element={<PrivateRoute><EditarDescuento /></PrivateRoute>} />
        <Route path="/ticket" element={<TicketPrinter />} />
        <Route path="/admin-liquidacion" element={<PrivateRoute><LiquidacionPropina /></PrivateRoute>} />
        <Route path="/admin-proveedores" element={<PrivateRoute><ProveedorAdmin /></PrivateRoute>} />
        <Route path="/admin-compras" element={<PrivateRoute><CompraAdmin /></PrivateRoute>} />
        <Route path="/admin-turno-caja" element={<PrivateRoute><TurnoCajaAdmin /></PrivateRoute>} />
        <Route path="/admin-flujo-caja" element={<PrivateRoute><FlujoCajaAdmin /></PrivateRoute>} />
        <Route path="/admin-esquemas" element={<PrivateRoute><EsquemasAdmin /></PrivateRoute>} />
        <Route path="/admin-cotizaciones" element={<PrivateRoute><CotizacionAdmin /></PrivateRoute>} />
        <Route path="/admin-gastos" element={<PrivateRoute><GastoAdmin /></PrivateRoute>} />
        <Route path="/test-ticket/:id" element={<TestTicketPage />} />
      <Route path="/ticket-printer/:id" element={<TicketPrinterWrapper />} />
        <Route path="/useregister" element={<PrivateRoute><UserRegister /></PrivateRoute>} />
<Route path="/admin-stock" element={<PrivateRoute><StockAdmin /></PrivateRoute>} />


      </Routes>
    </Router>
  );
}

export default App;
